import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  const ref = useScrollReveal();
  return <div ref={ref} className={className} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-177">
      {children}
    </div>;
}